import { apiCall, secondaryApi } from "./ApiUtils";

export const getAgentTokens = (isAffiliate=null, includeUser=false) => apiCall(`admin/sales-tokens?${isAffiliate !== null ? "&isAffiliate="+ isAffiliate: ""}${includeUser ? "&includeUser=1" : ""}`, {
    method: "GET",
}, null, secondaryApi)

export const getTrafficSources = (siteId) => apiCall(`sites/${siteId}/traffic-sources`, {
    method: "GET"
}, null)

export const authorizeRegion = (siteId) => apiCall(`sites/${siteId}/authorize`, {
    method: "POST"
}, null, secondaryApi)

export const getSites = (token, siteId=null) => apiCall(`sites${siteId ? "/"+siteId : ""}`, {
    method: "GET"
}, token)

export const getBilling = (siteId) => apiCall(`sites/${siteId}/billing`, {
    method: "GET"
}, null, secondaryApi)

export const generateBillingUpdate = (siteId) => apiCall(`sites/${siteId}/billing`, {
    method: "PUT"
}, null, secondaryApi)

export const getGmbVerificationStatus = (siteId) => apiCall(`sites/${siteId}/accounts/gmb/verification-status`, {
    method: "GET"
}, null, secondaryApi)

export const getOrgSalesToken = (siteId) => apiCall(`sites/${siteId}/sales-token`, {
    method: "GET"
}, null, secondaryApi)

export const downloadFranchescaAssessmentBySiteId = (assessmentId) => apiCall(`admin/franchesca-assessments/${assessmentId}/download`, {
    method: "GET"
}, null, secondaryApi, null, null, true)

export const getFranchescaAssessmentsBySiteId = (siteId) => apiCall(`admin/franchesca-assessments/${siteId}`, {
    method: "GET"
}, null, secondaryApi)

export const createFranchescaAssessmentsBySiteId = (siteId, type) => apiCall(`admin/franchesca-assessments/${siteId}`, {
    method: "POST",
    body: {
        type
    }
}, null, secondaryApi)

export const updateFranchescaAssessment = (assessment) => apiCall(`admin/franchesca-assessments/${assessment.assessmentId}`, {
    method: "PUT",
    body: {
        ...assessment
    }
}, null, secondaryApi)